import S from 'constants/string.const';
import alen from 'utils/arrays/alen.util';
import { firstOf } from 'utils/arrays/elements.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

const linkToCalendar = (options) => {
  const { stylists, salonId, week } = options ?? {};

  if (!salonId) return S.empty;

  const generalLink = `/salon/${salonId}/day/today`;
  if (1 !== alen(stylists)) return generalLink; // either no stylists or multiple ones

  const { id } = firstOf(stylists);
  if (!id || !week) return generalLink; // not all args are OK, but can still return for the general case

  // exactly one stylist and week exist
  return `/salon/${salonId}/week/${fromAnyToString(week)}/${id}`;
};

export default linkToCalendar;
